import { get } from '../../../helpers/axios';

const BASE_PATH = '/campaign-message/dashboard';

const BASE_PATH_BUSINESS = '/business';
//# API DE SERVICIOS PARA MODULO SHORTCODES

export const getDashboardData = (businessId, startDate,endDate) => get(`${BASE_PATH}/${businessId}?initDate=${startDate}&limitDate=${endDate}`);

export const getAllActiveBusiness = () => get(`${BASE_PATH_BUSINESS}/active`);


